exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blog-articles button[data-v-391313ec]{width:200px;background-color:#fff;margin:0 auto;position:relative;top:-160px;border:none;border-radius:5px;padding:20px 15px;font-size:18px}.blog-articles[data-v-391313ec]{width:100%;height:auto;padding-top:100px;display:flex;flex-direction:column;justify-content:center;background-color:#2e3192;margin-bottom:60px}.blog-articles h1[data-v-391313ec]{color:#fff;text-decoration:underline}.logo-nav-container[data-v-391313ec]{display:flex;flex-direction:row;justify-content:space-around;width:80%;margin:30px auto}.logo-nav-container .nav-list[data-v-391313ec]{color:#fff}.blog-headline img[data-v-391313ec]{margin:50 auto}@media (max-width:775px){.blog-headline img[data-v-391313ec]{width:90%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-391313ec","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BlogArticles.vue
// module id = 221
// module chunks = 0